import {
  useSearchPageFiltersQueryArgs,
  useSearchPageQueryArgs,
} from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/useSearchPageQueryArgs";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const usePrefetchSearchPage = () => {
  const queryClient = useQueryClient();
  const { productsQueryArgs } = useSearchPageQueryArgs();
  const { filtersQueryArgs } = useSearchPageFiltersQueryArgs();

  return useCallback(() => {
    queryClient.prefetchQuery({
      queryKey: productsQueryArgs.key,
      queryFn: productsQueryArgs.fn,
      staleTime: productsQueryArgs.staleTime,
    });

    queryClient.prefetchQuery({
      queryKey: filtersQueryArgs.key,
      queryFn: filtersQueryArgs.fn,
      staleTime: filtersQueryArgs.staleTime,
    });
  }, [
    filtersQueryArgs.fn,
    filtersQueryArgs.key,
    filtersQueryArgs.staleTime,
    productsQueryArgs.fn,
    productsQueryArgs.key,
    productsQueryArgs.staleTime,
    queryClient,
  ]);
};
